<template>
  <oie-header-switch
    :value="clientModel.useListPrice"
    is-for="list-price-switch"
    :label-text="tStatic('listPriceShowing')"
    @toggle="toggleCheckbox">
  </oie-header-switch>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import httpClient from '@/core/http-service'

export default {
  computed: {
    ...mapGetters('ui', ['useListPrice'])
  },
  methods: {
    ...mapActions('ui', ['toggleValue']),
    toggleCheckbox() {
      httpClient.post('auth/listprice', { showOnlyListPrice: !this.clientModel.useListPrice }).then((response) => {
        this.clientModel.useListPrice = !this.clientModel.useListPrice
        // this.toggleValue({ key: 'useListPrice' })
        // this.$store.dispatch('commerce/getCart', 0)
      })

      // todo something else
    }
  }
}
</script>
